import * as tslib_1 from "tslib";
import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import * as ɵngcc0 from '@angular/core';
let LinkDirective = class LinkDirective {
    constructor(viewContainer, templateRef, renderer, elementRef) {
        this.viewContainer = viewContainer;
        this.templateRef = templateRef;
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.inlineRef = null;
        // tslint:disable-next-line:no-input-rename
        this.editable = true;
        // tslint:disable-next-line:no-input-rename
        this.attrs = {};
    }
    ngOnChanges(changes) {
        if (changes['field'] || changes['editable'] || changes['attrs']) {
            this.viewContainer.clear();
            if (this.inlineRef) {
                this.inlineRef.remove();
                this.inlineRef = null;
            }
            this.updateView();
        }
    }
    updateView() {
        const field = this.field;
        if (this.editable && field && field.editableFirstPart && field.editableLastPart) {
            this.renderInlineWrapper(field.editableFirstPart, field.editableLastPart);
        }
        else if (field && (field.href || field.value)) {
            const props = field.href ? field : field.value;
            const linkText = field.text || field.value.text || field.href || field.value.href;
            const mergedAttrs = Object.assign({}, props, this.attrs);
            this.renderTemplate(mergedAttrs, linkText);
        }
    }
    renderTemplate(props, linkText) {
        const viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
        viewRef.rootNodes.forEach((node) => {
            Object.entries(props).forEach(([key, propValue]) => this.renderer.setAttribute(node, key, propValue));
            if (node.childNodes && node.childNodes.length === 0 && linkText) {
                node.textContent = linkText;
            }
        });
    }
    renderInlineWrapper(editableFirstPart, editableLastPart) {
        const span = this.renderer.createElement('span');
        span.className = 'sc-link-wrapper';
        span.innerHTML = editableFirstPart + editableLastPart;
        // assign attributes from template to inline wrapper
        const attrs = Object.assign({}, this.getElementAttrs(), this.attrs);
        Object.entries(attrs).forEach(([key, attrValue]) => this.renderer.setAttribute(span, key, attrValue));
        this.viewContainer.createEmbeddedView(this.templateRef);
        const parentNode = this.renderer.parentNode(this.elementRef.nativeElement);
        this.renderer.insertBefore(parentNode, span, this.elementRef.nativeElement);
        this.inlineRef = span;
    }
    getElementAttrs() {
        const view = this.templateRef.createEmbeddedView(null);
        const element = view.rootNodes[0];
        if (!element) {
            return {};
        }
        const attrs = {};
        for (let i = 0; i < element.attributes.length; i++) {
            const attr = element.attributes.item(i);
            if (attr) {
                attrs[attr.name] = attr.value;
            }
        }
        return attrs;
    }
};
LinkDirective.ɵfac = function LinkDirective_Factory(t) { return new (t || LinkDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
LinkDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: LinkDirective, selectors: [["", "scLink", ""]], inputs: { editable: ["scLinkEditable", "editable"], attrs: ["scLinkAttrs", "attrs"], field: ["scLink", "field"] }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
LinkDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: TemplateRef },
    { type: Renderer2 },
    { type: ElementRef }
];
tslib_1.__decorate([
    Input('scLinkEditable')
], LinkDirective.prototype, "editable", void 0);
tslib_1.__decorate([
    Input('scLinkAttrs')
], LinkDirective.prototype, "attrs", void 0);
tslib_1.__decorate([
    Input('scLink')
], LinkDirective.prototype, "field", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LinkDirective, [{
        type: Directive,
        args: [{ selector: '[scLink]' }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.TemplateRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { editable: [{
            type: Input,
            args: ['scLinkEditable']
        }], attrs: [{
            type: Input,
            args: ['scLinkAttrs']
        }], field: [{
            type: Input,
            args: ['scLink']
        }] }); })();
export { LinkDirective };
